var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"stay_in_touch",style:({'--progress': 0})},[_c('div',{staticClass:"container"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"right"},[_vm._t("default")],2)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('h4',[_vm._v("Stay In Touch")])])
}]

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/StayInTouch.vue